import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

type CreateSetupTrackerFollowUpEmail = {
  setupTrackerId: string;
  departmentId: string;
};

export const createSetupTrackerFollowUpEmail = async <
  T extends Record<string, unknown>,
>({
  query,
  departmentId,
  setupTrackerId,
  domain,
  headers,
}: FetchRequestArgs & CreateSetupTrackerFollowUpEmail): Promise<
  ReturnType<typeof fetchRequest>
> => {
  return fetchRequest<T>({
    domain,
    endpoint: `/v2/departments/${departmentId}/setup_trackers/${setupTrackerId}/follow_up_email`,
    headers,
    method: HTTPMethod.POST,
    query,
  });
};
